import { ReportsTable } from "@/admin/reports/ReportsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/reports")({
    component: ReportsTable,
});
